module.exports = __webpack_public_path__ + "static/image03-800-6cb95fc46aea09d1d166bf8f05840250.jpg";